<template>
    <div class="notice">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'noticelist',
    data: function () {
        return {
            
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.notice {
    width: 1200px;
    margin: 50px auto;
    text-align: center;
    font-size: 20px;
    text-align: left;
}
</style>
